import {useContext} from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import FlujosEstructureContext from 'context/FlujosEstructureContext';

let myAbilities = HelpAbility();

function Item({i, flujo: flu, deleteFlujoEstructure, predet}){
    
 const {setFlujoEstructure} = useContext(FlujosEstructureContext);
 const {_id, flujo, predeterminado} = flu;

 const handleIsUpdateForm = () => {
    const newFlu = {
        _id,
        flujo: flujo.map(flu => flu._id),
        predeterminado
    }
    setFlujoEstructure({...newFlu})
 }
 
 const handleDeleteFlujoEstructure = async () => {
    deleteFlujoEstructure({id: _id})
 }

  let flujoString = "";

 for(let i = 0; i < flujo.length; i++){
    if(i === (flujo.length - 1)){
        flujoString += `${flujo[i].nivel}`
    }else{
        flujoString += `${flujo[i].nivel} => `
    }
 }
 

 return (
   <tr style={predet ? {borderBottom: "2px solid black"} : {}}>
      <th className="text-center" scope="row">{i + 1}</th>
      <td className="text-center">{flujoString}</td>
      <td className="text-center">{predeterminado ?  <input className="form-check-input" type="checkbox" defaultChecked style={{pointerEvents: "none"}}/> : <input className="form-check-input" type="checkbox" defaultChecked disabled style={{pointerEvents: "none"}}/>}</td>

      {myAbilities.hasAny([C.A.FLUJOSSTRUCTURE.UPDATE, C.A.FLUJOSSTRUCTURE.DELETE]) && <td className="text-center d-flex">
          {myAbilities.has(C.A.FLUJOSSTRUCTURE.UPDATE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-success me-2"
                      onClick={handleIsUpdateForm}>
                  <i className="bi bi-pencil-square"/>
              </button>
          </OverlayTrigger>}
          {myAbilities.has(C.A.FLUJOSSTRUCTURE.DELETE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-danger"
                      onClick={handleDeleteFlujoEstructure}>
                  <i className="bi bi-trash"/>
              </button>
          </OverlayTrigger>}
      </td>}
  </tr>
 )
}
export default Item

